
<div
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = true" cdkOverlayOrigin class="filter-button status-filter payapp-multi-filter flex flex-row gap-[20px]" type="button"
  >
  <div class="label text-type-8">{{ buttonLabel }}</div>
  <mat-icon
    class="filter-icon"
    svgIcon="filters"
    />
</div>

<ng-template
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  cdkConnectedOverlay
  >
  <div class="project-details-page-status-filter-popup">
    <div class="filter-tabs" role="tablist">
      <button
        type="button"
        class="filter-tab"
        [class.active]="activeTab === 'status'"
        (click)="selectTab('status')"
        >
        Status
      </button>
      @if (showSitesTab) {
        <button
          type="button"
          class="filter-tab"
          [class.active]="activeTab === 'sites'"
          (click)="selectTab('sites')"
          >
          Sites
        </button>
      }
      <button
        type="button"
        class="filter-tab"
        [class.active]="activeTab === 'createdBy'"
        (click)="selectTab('createdBy')"
        >
        Created by
      </button>
    </div>

    <div class="filter-tab-content">
      @if (activeTab === 'status' && !isContractorMode) {
        <app-checkbox-list-with-filter
          (selectionChange)="onStatusCheckboxChange($event)"
          [displaySearch]="false"
          [displaySelectAll]="true"
          [options]="statusOptions"
          [parentFormGroup]="searchForm"
          controlName="statusSearch"
          />
      }
      @if (activeTab === 'status' && isContractorMode) {
        <app-checkbox-list-with-filter
          (selectionChange)="onContractorStatusCheckboxChange($event)"
          [displaySearch]="false"
          [displaySelectAll]="true"
          [options]="contractorStatusOptions"
          [parentFormGroup]="searchForm"
          controlName="contractorStatusSearch"
          />
      }
      @if (activeTab === 'sites' && showSitesTab) {
        <app-checkbox-list-with-filter
          (selectionChange)="onSiteCheckboxChange($event)"
          [displaySearch]="true"
          [displaySelectAll]="true"
          [options]="sitesOptions"
          [parentFormGroup]="searchForm"
          controlName="sitesSearch"
          />
      }
      @if (activeTab === 'createdBy') {
        <app-checkbox-list-with-filter
          (selectionChange)="onCreatorCheckboxChange($event)"
          [displaySearch]="true"
          [displaySelectAll]="true"
          [options]="creatorOptions"
          [parentFormGroup]="searchForm"
          controlName="creatorsSearch"
          />
      }
    </div>
  </div>
</ng-template>
